import { render, staticRenderFns } from "./PreferencesSettingsIcon.vue?vue&type=template&id=fc2606ca&scoped=true"
import script from "./PreferencesSettingsIcon.vue?vue&type=script&lang=js"
export * from "./PreferencesSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2606ca",
  null
  
)

export default component.exports